module.exports = __webpack_public_path__ + "static/media/Fuzz Modeler Mid Gain VR.dbfb77b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Fuzz Modeler Mid Gain VR.mp3
// module id = ESVV
// module chunks = 12